import {
  disableGoogleAnalytics,
  enableGoogleAnalytics,
  initGoogleAnalytics,
  isGoogleAnalyticsInitialized,
  parseGoogleAnalyticsConfig,
  trackGaPageView,
} from '~/utils/googleAnalytics'
import { parseGoogleTagManagerConfig } from '~/utils/googleTagManager'
import { markTrackingLoaded } from '~/utils/trackingScope'

export default defineNuxtPlugin(async () => {
  const { fetchSettings, settings, loaded } = useSiteSettings()
  const { analytics, hydrate } = useCookieConsent()
  const { trackableShop } = useTrackingScope()
  const router = useRouter()

  if (!loaded.value) {
    await fetchSettings()
  }

  hydrate()

  async function syncGoogleAnalytics() {
    const slug = trackableShop()
    if (!slug) return

    const gtmConfig = parseGoogleTagManagerConfig(settings.value.google_tag_manager)
    if (gtmConfig.enabled && gtmConfig.containerIds.length) return

    const config = parseGoogleAnalyticsConfig(settings.value.google_analytics)
    if (!config.enabled || !config.measurementIds.length) return

    if (!analytics.value) {
      disableGoogleAnalytics()
      return
    }

    enableGoogleAnalytics()

    if (!isGoogleAnalyticsInitialized()) {
      markTrackingLoaded(slug)
      const path = router.currentRoute.value.fullPath
      if (await initGoogleAnalytics(config.measurementIds)) {
        trackGaPageView(path)
      }
    }
  }

  watch([analytics, loaded, () => router.currentRoute.value.path], () => {
    void syncGoogleAnalytics()
  }, { immediate: true })

  router.afterEach((to) => {
    if (!analytics.value || !trackableShop(to)) return
    trackGaPageView(to.fullPath)
  })
})
